module.exports = __webpack_public_path__ + "static/media/BiPartingIn.046e3d10.svg";